export default __webpack_public_path__ + "static/media/tel_icon.ca3cc68b.svg";